import React, { useEffect } from "react";
import { flightAiRandomLoadingMessages } from "./flightAiRandomLoadingMessages";
import { PhosphorHourglass } from "components/Atoms/PhosphorIcon";

type RandomLoadingMessage = {
  message: string
  weight: number
}

interface RandomLoadingMessagesProps {
  changeTimeMs: number
  dotSpeedMs: number
  messages: RandomLoadingMessage[]

}

const getRandomLoadingMessage = (loadingMessages: RandomLoadingMessage[]) => {
  const totalWeight = loadingMessages.reduce((sum, item) => sum + item.weight, 0);
  let random = Math.random() * totalWeight;
  for (const item of loadingMessages) {
    random -= item.weight;
    if (random <= 0) return item;
  }
  return loadingMessages[loadingMessages.length - 1];
}

export const RandomLoadingMessages = (props: RandomLoadingMessagesProps) => {
  const [message, setMessage] = React.useState<string>(getRandomLoadingMessage(props.messages).message);
  const [dotCounter, setDotCounter] = React.useState<number>(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setDotCounter((prev) => (prev + 1) % 4);
    }, props.dotSpeedMs);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setMessage(getRandomLoadingMessage(props.messages).message);
    }, props.changeTimeMs);
    return () => clearInterval(interval);
  }, []);

  return <div className="message ui purple flex gap">
    <div style={{ height: 14 }}>
      <PhosphorHourglass iconSize="small" />
    </div>
    {message}{".".repeat(dotCounter)}
  </div>;
}

export const FlightAiRandomLoadingMessages = () =>
  <RandomLoadingMessages
    messages={flightAiRandomLoadingMessages}
    changeTimeMs={4000}
    dotSpeedMs={500}
  />